import { Dialog, Spinner } from "construct-ui";
import checkboxInputComponent from "../../../components/common/checkbox-input.component";
import { messageComponent } from "../../../components/message/message.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import masterConfigurationModel from "../../../models/config-master.model";
import loginModel from "../../../models/login.model";
import ViewBase from "../../view-base.view";
import ColumnValuesView from "./column-values.view";
import MasterViewDetailsView from "./master-view-details.view";

export default function MasterConfigurationView() {

  ViewBase.call(this);
  let onChange = (row) => { }
  let isViewOpen = false;
  let selectedSubsidiaryCode = "";
  let selectedDescription = "";
  let selectedRecordType = "";
  let inputDatModel = {
    pageIndex: 1, pageSize: 10, totalSize: 0, recordType: "", allSubsidiaryYN: "N", includeSystemYN: false, data: [], subsidiaryCode: loginModel.credentials.subsidiaryCode
  };
  let isLoading = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";

  let _clearFilter = () => {
    inputDatModel.pageIndex = 1;
    inputDatModel.pageSize = 10;
    inputDatModel.recordType = "";
    inputDatModel.allSubsidiaryYN = "N"
    inputDatModel.includeSystemYN = false;
    inputDatModel.subsidiaryCode = loginModel.credentials.subsidiaryCode;
  }

  let _search = () => {
    inputDatModel.pageIndex = 1;
    _loadMasterConfigurationList();
  }

  let _loadMasterConfigurationList = () => {
    isLoading = true;
    masterConfigurationModel.getConfigMasterList(
      (result) => {
        isLoading = false;
        inputDatModel.data = result.data;
        inputDatModel.totalCount = result.total;
        inputDatModel.pageIndex = result.pageIndex;
        inputDatModel.pageSize = result.pageSize;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel
    )
  }

  let _downloadMasterConfigurationList = () => {
    isLoading = true;
    masterConfigurationModel.downloadMCList(
      (result) => {
        isLoading = false;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel
    )
  }

  let _downloadDataList = (rtype, sub, locations) => {
    isLoading = true;
    masterConfigurationModel.downloadData(
      (result) => {
        isLoading = false;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      rtype, sub, locations
    )
  }

  let _downloadManual = (manualId, name) => {
    isLoading = true;
    masterConfigurationModel.downloadManual(
      (result) => {
        isLoading = false;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      manualId, name
    )
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    _loadMasterConfigurationList();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    _loadMasterConfigurationList();
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onChange) {
        onChange = vnode.attrs.onChange;
      }
     
      _search();
    },
    view: (vnode) => {
      return [
        m('.row',
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.col-12',
            // Search section
            m('.card.mb-3',
              m('.card-body',

                m('.row.g-4',
                  m('.col-md-4',
                    m('label.form-label', this.getText("LT00000564", "Record Type")),
                    m('input[type=text][placeholder=' + this.getText("LT00000564", "Record Type") + '][value="' + inputDatModel.recordType + '"].form-control.form-control-bg', { onchange: (e) => { inputDatModel.recordType = e.target.value } })
                  ),
                  m('.col-md-2',
                    m('.col.mt-5',
                      m(checkboxInputComponent, {
                        label: this.getText("LT00000565", "All Subsidiaries"),
                        value: inputDatModel.subsidiaryCode == '' ? true : false,
                        onclick: (e) => {
                          if (e.target.checked) {
                            inputDatModel.subsidiaryCode = "";
                          }
                          else {
                            inputDatModel.subsidiaryCode = loginModel.credentials.subsidiaryCode;
                          }

                        },
                      }),
                    ),
                  ),
                  m('.col-md-3',
                    m('.col.mt-5',
                      m(checkboxInputComponent, {
                        label: this.getText("LT00000566", "Include System records (Empty Subsidiary)"),
                        value: inputDatModel.includeSystemYN,
                        onclick: (e) => {
                          inputDatModel.includeSystemYN = e.target.checked
                        },
                      }),
                    ),
                  ),
                  m('.col-md-3.gap-2.d-flex.align-items-end.justify-content-end.justify-content-md-start',
                    m('button.btn.btn-primary', { onclick: _search }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),

            // Table section
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: () => { _downloadMasterConfigurationList() } },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table", [
                        m("thead.thead-bggrey",
                          m("tr.align-middle", [
                            m("th", { "scope": "col" }, this.getText("LT00000567", "Sub")),
                            m("th", { "scope": "col" }, this.getText("LT00000564", "Record Type")),
                            m("th", { "scope": "col" }, this.getText("LT00000012", "Description")),
                            m("th", { "scope": "col" }, this.getText("LT00000568", "Count")),
                            m("th", { "scope": "col" }, this.getText("LT00000203", "Manual")),
                            m("th", { "scope": "col" }, this.getText("LT00000569", "Keys")),
                            m("th", { "scope": "col" }, this.getText("LT00000570", "Attributes")),
                            m("th.center", { "scope": "col" }, this.getText("LT00000033", "Actions"))
                          ])
                        ),
                        m("tbody",
                          inputDatModel.data.length == 0 &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": "9" }, this.getText("EM00000141", "No records found."))
                          ),
                          inputDatModel.data.map(gc => [
                            m("tr", [
                              m("td", { "style": "width:3%" }, gc.subsidiaryCode),
                              m("td", { style: "max-width: 100px; white-space: initial;" }, gc.recordType),
                              m("td", { style: "max-width: 170px; white-space: initial;" }, m('span', gc.recordDescription)),
                              m("td", gc.recordCount),
                              m("td", { "style": "width:3%" },
                                gc.manual != "" ? m('i.bi.bi-download.list-action-icon[title="Download"]', {
                                  onclick: () => {
                                    _downloadManual(gc.manual, gc.recordType)
                                  }
                                }) : ""
                              ),
                              m("td", m(ColumnValuesView, { data: gc.keys, type: "Keys" })),
                              m("td", m(ColumnValuesView, { data: gc.attributes, type: "Attributes" })),
                              m("td.center",
                                m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', { onclick: () => { onChange(gc) } }),
                                m('i.bi.bi-info-lg.list-action-icon[title="Info"]', {
                                  onclick: () => {
                                    isViewOpen = true;
                                    selectedSubsidiaryCode = gc.subsidiaryCode;
                                    selectedRecordType = gc.recordType;
                                    selectedDescription = gc.recordDescription;
                                  }
                                }),
                                m('i.bi.bi-download.list-action-icon[title="Download"]', {
                                  onclick: () => {
                                    console.log('gc===>', gc);
                                    _downloadDataList(gc.recordType, gc.subsidiaryCode, gc.location)
                                  }
                                }),
                              )
                            ])
                          ]),
                        )
                      ])
                    ),
                    !isLoading &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: inputDatModel.pageIndex,
                        pageSize: inputDatModel.pageSize,
                        totalItems: inputDatModel.totalCount,
                        onPageChanged: onPageChanged,
                        onPageSizeChanged: onPageSizeChanged
                      })
                    )
                  )
                )
              )
            )
          ),
          m(Dialog, {
            isOpen: isViewOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isViewOpen = false; selectedSubsidiaryCode = ""; selectedRecordType = "", selectedDescription = "" },
            title: this.getText("LT00000571", "Master View Details"),
            content: m(MasterViewDetailsView, { onAddClose: () => { isViewOpen = false }, subsidiary: selectedSubsidiaryCode, recordType: selectedRecordType, description: selectedDescription }),
            "class": "cui-dialog-xxl"
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
